import { RouteRecordRaw } from "vue-router";

const first = (v: unknown) => Array.isArray(v) ? v[0] : v;

export const goRoutes: RouteRecordRaw[] = [
	{
		path: "/go/organizations/subscription-settings",
		redirect: (to) => {
			const organizationId = String(first(to.query.organizationId ?? ""));
			if (!organizationId) return { name: "NotFound" };

			// forward unused query keys if you like (e.g., utm_*):
			const { organizationId: _omit, ...rest } = to.query;

			return {
				name: "organization-settings-subscription",
				params: { organizationId },
				query: rest,
			};
		},
	},
	{
		path: "/go/productions/subscription-callback",
		redirect: (to) => {
			const productionId = String(first(to.query.productionId ?? ""));
			if (!productionId) return { name: "NotFound" };

			// orgId is present in the vanity URL but not required by the target,
			// so we drop it unless you want to forward it as query:
			const { productionId: _p, organizationId: _o, ...rest } = to.query;

			return {
				name: "production-activation-callback",
				params: { productionId },
				query: rest, // keep other query params if useful
			};
		},
	},
	{
		path: "/go/organizations/subscription-callback",
		redirect: (to) => {
			const organizationId = String(first(to.query.organizationId ?? ""));
			if (!organizationId) return { name: "NotFound" };

			// orgId is present in the vanity URL but not required by the target,
			// so we drop it unless you want to forward it as query:
			const { organizationId: _o, ...rest } = to.query;

			return {
				name: "organization-activation-callback",
				params: { organizationId },
				query: rest, // keep other query params if useful
			};
		},
	},
];
